export const STRIPE_URL = "https://buy.stripe.com/00wcN61I1gJEaLhc9c1ZS02";
export const STRIPE_EMAIL_CHECK_URL = "https://buy.stripe.com/fZu00k86p50WaLhddg1ZS03";
export const STRIPE_EU_PACK_URL = "https://buy.stripe.com/8x28wQ9at3WS6v18X01ZS04";
export const EUR_LEX_GSPR_URL = "https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32023R0988";
export const EMAIL = "info@ey-technology.com";
export const ADDRESS_LINES = [
  "EY TECH LLC",
  "520 Robinson Lane",
  "Unit 4 E 22",
  "Wilmington, DE 19805",
  "USA",
];
